<div class="posterListHolder">
    <div class="title" [innerHTML]="title | safeHtml"></div>

    <div class="sliderHolder" #sliderHolder>
        <div class="slider" #slider>
            <app-poster-card #elem [movie]="movie" *ngFor="let movie of movies"></app-poster-card>
        </div>

        
    </div>
    <div class="arrows">
        <div class="left" (click)="prev()" [ngClass]="{enabled: prevEnabled}">
            <app-round-arrow-left></app-round-arrow-left>
        </div>
        <div class="right" (click)="next()" [ngClass]="{enabled: nextEnabled}">
            <app-round-arrow-right></app-round-arrow-right>
        </div>
    </div>
</div>
